module.exports = __webpack_public_path__ + "img/not-confirmed.aaa07b37.svg";